import { Body1, Button, UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';
import { NBSP } from 'shared/constants/symbols';

import * as styles from './styles.css';

export interface INewbuildingCompareFlightBannerProps {
  onClick: () => void;
}

export const NewbuildingCompareFlightBanner: React.FC<INewbuildingCompareFlightBannerProps> = ({ onClick }) => {
  // Кликабелен весь баннер: клик по кнопке всплывает до контейнера, своего обработчика у кнопки нет
  return (
    <div className={styles['container']} data-testid="NewbuildingCompareFlightBanner" onClick={onClick}>
      <div className={styles['content']}>
        <div className={styles['text-group']}>
          <UIHeading1>ЖК познаются в{NBSP}сравнении</UIHeading1>
          <Body1>Цены, метраж, инфраструктура: покажем всё важное</Body1>
        </div>

        <Button data-testid="NewbuildingCompareFlightBannerButton" size="M" type="button">
          Как работает сравнение
        </Button>
      </div>

      <div aria-hidden={true} className={styles['image-slot']} />
    </div>
  );
};
